import { navigate } from '@redwoodjs/router';
import { Head, useQuery } from '@redwoodjs/web';

import { GET_CHECK_IN_CALLS } from 'src/graphql/queries/getCheckInCalls.query';
import { PageContent } from 'src/layouts/MainLayout/PageContent';

import CheckInCallSetupTable from './components/CheckInCallSetupTable';

export const CheckInCallSetupPage = () => {
    const { data, loading, refetch } = useQuery(GET_CHECK_IN_CALLS, {
        fetchPolicy: 'network-only',
    });

    const handleAddCheckInCall = () => {
        navigate(`/config/check-in-call-view/checkInId`);
    };
    return (
        <PageContent
            heading="Check-in Call Setup"
            subHeading="Manage and modify check-in calls as needed."
        >
            <Head>
                <title>Check-in Call Setup</title>
                <meta name="description" content="Manage and modify check-in calls as needed." />
            </Head>
            <CheckInCallSetupTable
                handleAddCheckInCall={handleAddCheckInCall}
                data={data ? data?.getCheckInCalls : []}
                loading={loading}
                refetch={() => refetch()}
            />
        </PageContent>
    );
};

export default CheckInCallSetupPage;
